import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class DefineIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 12"><path d="M2.3 4h1.5c.2 0 .4-.2.4-.4V2.2c0-.2-.2-.4-.4-.4H2.3c-.2 0-.4.2-.4.4v1.5c0 .1.2.3.4.3zm.3-1.5h.7v.7h-.7v-.7zm-.3 5h1.5c.2 0 .4-.2.4-.4V5.7c0-.2-.2-.4-.4-.4H2.3c-.2 0-.4.2-.4.4v1.5c0 .1.2.3.4.3zM2.6 6h.7v.7h-.7V6zm6.5-6H.8C.6 0 .5.2.5.4v11.2c0 .2.2.4.4.4h8.3c.2 0 .4-.2.4-.4V.4C9.4.2 9.3 0 9.1 0zm-.4 11.2H1.2V.7h7.5v10.5zM4.8 2.5h2.9v.7H4.8v-.7zm0 3.5h2.9v.7H4.8V6zM1.9 9.2h5.8v.7H1.9v-.7z" fillRule="evenodd" clipRule="evenodd" fill="#8d979a"/></svg>
        )
    }
}

export default withCssClassName(DefineIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/define-icon.js